import './title.css';

export default function TitleOverlay() {
  return (
    <div className="title-panel">
      <h2 className="title">Find the space station</h2>
      <p className="description">254 miles up</p>
    </div>
  );
}